import React, { Component } from 'react';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
// import GD from "../RestAPI/getData";
import language from '../../../assets/languages/language';
import ModalComponent from '../../Common/Modal';
import Cfa3SubscriptionCheck from '../../RestAPI/Cfa3Subscription';
import PartnerCfa3SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa3Subscription';
import AlertMessage from '../../config/alertMessage';
// import { getDeviceDetails } from "../../common/deviceDetails";
import { examNameAccordingToDB } from '../../../common/constant';
import { getIpAddress } from '../../../common/getIpAddress';
/* eslint-disable*/
class Cfa3EssayQuestions extends Component {
  constructor(props) {
    super(props);
    var messageTitle_cfa_3 = `<i class="icon-info icons font-2xl d-block "></i>`;
    this.state = {
      alert_status: false,
      MessageTitle: messageTitle_cfa_3,
      MessageContent: AlertMessage.messageContent_cfa_3,
      chapters: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      selectedmenu: 'cfa_3',
      showFreePremium: '',
      userType: '',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    //this._getReadings = this._getReadings.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  async componentDidMount() {
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });

    if (localStorage.getItem('selectedmenu') === 'frm') {
      this.context.router.push({
        pathname: '/frm/questionbank/',
        state: {
          token: storage_session['token'],
          idname: storage_session['idname'],
        },
      });
    }

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    await FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getcfa3_essayques', data).then(
      async resp => {
        if (resp.success) {
          this.setState({ ValidToken: true, chapters: resp.cfa3essayques });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );

    var data = { token: this.state.token, idname: this.state.idname };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ showFreePremium: true, userType: 'free' });
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var = await PartnerCfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  examPlanData,
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false, userType: 'paid' });
                } else {
                  this.setState({ showFreePremium: true, userType: 'free' });
                }
              } else {
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.setState({ showFreePremium: true, userType: 'free' });
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = Cfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );

                if (isInArray_var) {
                  this.setState({ showFreePremium: false, userType: 'paid' });
                } else {
                  this.setState({ showFreePremium: true, userType: 'free' });
                }
              } else {
                ('fail');
              }
            },
          );
        }
      }
    });
  }

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  pdfOpen(pdfdata, e) {
    if (this.state.userType === 'paid') {
      // const result = getDeviceDetails();
      const data = {
        token: this.state.token,
        idname: this.state.idname,
        id: pdfdata.id,
        city: this.state.user_city,
        country: this.state.user_country,
        state: this.state.user_state,
        continent: this.state.user_continent,
        ip: this.state.user_ip,
      };
      FD.callAPI(
        App_data.backend_api + '/cfa_3question_bank/trackUserMockExamPPTDownload',
        data,
      ).then(resp => {
        if (resp.success) {
          var myWindow = window.open(
            pdfdata.pdf_file,
            // `${window.location.origin +
            //   "/pdf/cfa3EssayQuesPdf/" +
            //   pdfdata.pdf_file}`
          );
          myWindow.focus();
        }
        return resp;
      });
    } else {
      this.toggleAlert();
    }
  }

  render() {
    let chapters = this.state.chapters;
    let data = '';
    if (this.state.chapters.length) {
      data = chapters.map(item => (
        <div className='col-md-6 col-lg-6 col-xl-4 free-premium-section question_box' key={item.id}>
          <div
            className='question_bank_wrap pointer_class'
            onClick={this.pdfOpen.bind(this, item)}
            id={item.id}
            value={item.pdf_file}
          >
            {this.state.showFreePremium ? (
              <div className='tag-tile premium'> {language.LC().PREMIUM} </div>
            ) : null}
            <div className='margin_bottom_30'>
              <img
                src={App_data.frontend_url + '/img/mockexams/ebook_icon.svg'}
                className=''
                width='50'
                alt=''
              />
            </div>
            <div className='' key={item.id}>
              <div className='question_title' key={item.id} value={item.id}>
                <a>{item.essay_ques_name}</a>
              </div>
              <ul key={item.pdf_file}>
                <li>
                  <span>
                    <img
                      src={App_data.frontend_url + '/img/mockexams/print_icon.svg'}
                      className=''
                      width='20'
                      alt=''
                    />
                  </span>
                  <span>
                    {language.LC().PRINT}
                    {/*Ready to Print*/}
                  </span>
                  <div className='tootip_box'>{language.LC().READY_FOR_PRINT}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-12 margin_bottom_20'>
            <h1 className='section_head'>
              {language.LC().CFA_LEVEL_III_PRINTABLE_ESSAY_QUESTIONS}
            </h1>
          </div>
          <div className='col-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <div className='card-block'>
                  <div className='row'>{data}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
          exam={examNameAccordingToDB.CFA_LEVEL_3}
        />
      </div>
    );
  }
}

export default Cfa3EssayQuestions;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3EssayQuestions/Cfa3EssayQuestions.js